/**
 * Component Registry for The Clairborne Apartment Homes
 * 
 * Inherits from @vibesites-price-brothers/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-price-brothers/theme-preferred/registry';
import { SisterProperties } from './components/SisterProperties';
import { FloorplansList } from './components/FloorplansList';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { ContactUs } from './components/ContactUs';
import { AccessibilityHero } from './components/AccessibilityHero';
import { AmenitiesHero } from './components/AmenitiesHero';
import { ApplyNowHero } from './components/ApplyNowHero';
import { ContactHero } from './components/ContactHero';
import { FaqHero } from './components/FaqHero';
import { FeaturedFloorPlanHero } from './components/FeaturedFloorPlanHero';
import { FloorPlansHero } from './components/FloorPlansHero';
import { GalleryHero } from './components/GalleryHero';
import { InteractiveMapHero } from './components/InteractiveMapHero';
import { NeighborhoodHero } from './components/NeighborhoodHero';
import { OneBedroomHero } from './components/OneBedroomHero';
import { PetPolicyHero } from './components/PetPolicyHero';
import { PreferredEmployerHero } from './components/PreferredEmployerHero';
import { PrivacyPolicyHero } from './components/PrivacyPolicyHero';
import { ResidentAccessHero } from './components/ResidentAccessHero';
import { ReviewsHero } from './components/ReviewsHero';
import { ScheduleATourHero } from './components/ScheduleATourHero';
import { SisterPropertiesHero } from './components/SisterPropertiesHero';
import { SitemapHero } from './components/SitemapHero';
import { StudiosHero } from './components/StudiosHero';
import { ThankYouHero } from './components/ThankYouHero';
import { ThreeBedroomsHero } from './components/ThreeBedroomsHero';
import { TownhomesHero } from './components/TownhomesHero';
import { TwoBedroomsHero } from './components/TwoBedroomsHero';
import { VirtualTourHero } from './components/VirtualTourHero';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  SisterProperties,
  FloorplansList,
  Footer,
  Header,
  ContactUs,
  AccessibilityHero,
  AmenitiesHero,
  ApplyNowHero,
  ContactHero,
  FaqHero,
  FeaturedFloorPlanHero,
  FloorPlansHero,
  GalleryHero,
  InteractiveMapHero,
  NeighborhoodHero,
  OneBedroomHero,
  PetPolicyHero,
  PreferredEmployerHero,
  PrivacyPolicyHero,
  ResidentAccessHero,
  ReviewsHero,
  ScheduleATourHero,
  SisterPropertiesHero,
  SitemapHero,
  StudiosHero,
  ThankYouHero,
  ThreeBedroomsHero,
  TownhomesHero,
  TwoBedroomsHero,
  VirtualTourHero,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
